import { createFileRoute } from '@tanstack/react-router'

import { TagsPage } from '#/modules/catalog/tags-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/tags')({
  component: TagsPage,
  validateSearch: validateListSearch,
})
